import React, { useEffect } from 'react';
import { TextField } from '@creditas/input';
import { InputContainer } from './errorInput.style';

import { ErrorInputInterface } from '../../types/errorInput.types';

const ErrorInput: React.FC<ErrorInputInterface> = (
  props: ErrorInputInterface,
) => {
  useEffect(() => {
    if (props.id) {
      const el = document.getElementById(props.id);
      el?.setAttribute('autocomplete', 'off');
    }
  }, [props.id]);
  return (
    <InputContainer>
      <TextField {...props} />
    </InputContainer>
  );
};

export default ErrorInput;
